export default __webpack_public_path__ + "static/media/DanhsachHDNT.588daf68.docx";